import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageMemberSearchLayer from "../../../components/Admin/ManageMemberSearchLayer";

const ManageMemberSearch = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageMemberSearchLayer />
      </MasterLayout>
    </>
  );
};

export default ManageMemberSearch;
